import { Link } from 'react-router-dom';

export function GuidePromoBanner() {
  return (
    <Link
      to="/tools/guide"
      className="card-hover border-primary-200/80 from-primary-50 group flex items-center gap-4 border bg-gradient-to-br via-white to-violet-50 p-4 sm:p-5"
    >
      <span className="bg-primary-600 flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl text-2xl shadow-sm">
        ✨
      </span>
      <span className="min-w-0 flex-1">
        <span className="flex flex-wrap items-center gap-2">
          <span className="group-hover:text-primary-800 text-base font-bold text-gray-900">
            Mylighthouse Guide
          </span>
          <span className="bg-primary-600 rounded-full px-2 py-0.5 text-[10px] font-bold uppercase tracking-wide text-white">
            AI
          </span>
        </span>
        <span className="mt-1 block text-sm text-gray-600">
          Ask how to book therapy, use tools, or find support in the app.
        </span>
      </span>
      <span className="text-primary-600 shrink-0 text-sm font-bold transition-transform group-hover:translate-x-0.5">
        Open →
      </span>
    </Link>
  );
}
